module.exports = __webpack_public_path__ + "img/bf.564329b0.svg";